const ALGO_PX = [
  '.......##...',
  '......###...',
  '......###...',
  '.....##.###.',
  '....##..###.',
  '....##..##..',
  '...##..###..',
  '...##..####.',
  '..##..##.##.',
  '.###..##.##.',
  '.##..##...##',
  '##..###...##',
]

const AlgoMark = ({ className = '' }: { className?: string }) => (
  <svg
    className={`px-algo ${className}`.trim()}
    viewBox={`0 0 ${ALGO_PX[0].length} ${ALGO_PX.length}`}
    aria-hidden="true"
    focusable="false"
    shapeRendering="crispEdges"
  >
    {ALGO_PX.flatMap((row, y) =>
      [...row].flatMap((cell, x) =>
        cell === '#'
          ? [
              <rect
                key={`${x}-${y}`}
                x={x}
                y={y}
                width={1}
                height={1}
                fill="currentColor"
              />,
            ]
          : [],
      ),
    )}
  </svg>
)

export default AlgoMark
